import React, { useState } from "react";
import { Accordion, Badge, Row, Col, Button,Card,Container, Spinner,Modal } from 'react-bootstrap';
import { FaArrowLeft, FaChalkboardTeacher, FaUsers, FaUserGraduate,FaImage,FaVideo,FaBookOpen,FaBook  } from 'react-icons/fa';

import useDayPlan from "./tables/dayPlan/useDayPlan";
import './dayPlan.css'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ModalShowVideos, ModalShowImages } from "./modelDayplanImagesAndVideos";
import CommonTableFilters from "commonFilterComponent/commonFilterComponent";

// Generate Random Light Colors
const getRandomColor = () => {
  const colors = ["#FFB6C1", "#FFD700", "#98FB98", "#87CEFA", "#FF69B4", "#FFA07A", "#AFEEEE", "#DDA0DD"];
  return colors[Math.floor(Math.random() * colors.length)];
};

const DayPlan = () => {
  // let { title, data } = useDayPlan();
  const [selectedImages, setSelectedImages] = useState(null); // State for selected images
  const [selectedVideos, setSelectedVideos] = useState(null); // State for selected videos
  const [showImageModal, setShowImageModal] = useState(false); // State for showing image modal
  const [showVideoModal, setShowVideoModal] = useState(false); // State for showing video modal
 const [selectedKey, setSelectedKey] = useState("");
  const [showModal, setShowModal] = useState(false);

  const keyLabels = {
    homework: "Homework",
    conclusion: "Conclusion",
    studentWillDo: "Student Will Do"
  };

  const openModal = (key) => {
    setSelectedKey(key);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedKey("");
    setShowModal(false);
  };

  const lessonTypes = [
    { type: 'I Do', icon: <FaChalkboardTeacher />, color: 'primary' },
    { type: 'We Do', icon: <FaUsers />, color: 'success' },
    { type: 'You Do', icon: <FaUserGraduate />, color: 'warning' },
  ];
 const [filters, setFilters] = useState({}); // 👈 maintain filters in state
  const { title, description, data, tableInstance } = useDayPlan(filters); // 👈 call hook here ONCE
  const {loader} = tableInstance
  const history = useHistory();
  // this only updates filters, does not call hook
  const handleFilterChange = (updatedFilters) => {
    setFilters(updatedFilters); // 👈 triggers useEffect inside useHomework
  };

  // Open image modal and set related images
  const handleImageIconClick = (images) => {
    setSelectedImages(images);
    setShowImageModal(true);
  };
    const handleVideoIconClick = (videos) => {
    setSelectedVideos(videos);
    setShowVideoModal(true);
  };

  return (
    <div className="dayplan-crazy-container">
      {/* Page Title */}
      <Row className="justify-content-center text-center mb-4">
        <Col xs={12}>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <FaArrowLeft
              className="cursor-pointer text-primary"
              size={24}
              onClick={() => history.goBack()}
            />
            <h2 className="small-title flex-grow-1 text-center mt-2">
              Lesson Plan
            </h2>
          </div>
        </Col>
        <CommonTableFilters onFilterChange={handleFilterChange} />
      </Row>

      {filters?.subjectId && (
        <Row className="mb-4 justify-content-center">
          <Col xs={12} md={4} lg={3} className="mb-3 mb-md-0">
            <Card className="text-center shadow-sm border-0">
              <Card.Body className="py-3" style={{ background: 'linear-gradient(135deg, #4e73df, #1cc88a)', color: '#fff', borderRadius: '0.5rem' }}>
                <h5 className="mb-0">
                  Total Lessons (
                  {filters?.totalLessons != null ? filters.totalLessons : '-'}
                  )
                </h5>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4} lg={3}>
            <Card className="text-center shadow-sm border-0">
              <Card.Body className="py-3" style={{ background: 'linear-gradient(135deg, #f6c23e, #e74a3b)', color: '#fff', borderRadius: '0.5rem' }}>
                <h5 className="mb-0">
                  Total Plans (
                  {filters?.totalPlans != null ? filters.totalPlans : '-'}
                  )
                </h5>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
      {!filters?.lessonId ? (
  // 🔹 Case 1: No lesson selected
  <Col className="text-center mt-5">
    <div className="alert alert-info" role="alert">
      <h5>No Lesson Selected</h5>
      <p>Please select a lesson from the filters above to view the content.</p>
    </div>
  </Col>
) : loader ? (
  // 🔹 Case 2: Loader while fetching data
  <div className="d-flex justify-content-center align-items-center py-5">
    <Spinner animation="border" variant="primary" role="status" />
    <span className="ms-2">Loading Day Plans...</span>
  </div>
) : data.length === 0 ? (
  // 🔹 Case 3: No data found
  <div className="text-center py-5">
    <h5 className="text-muted">No Day Plans Found</h5>
  </div>
) : 
        (<Accordion className="crazy-accordion">
        {data.map((lesson, index) => (
          <Accordion.Item eventKey={String(index)} key={index}>
         <Accordion.Header style={{ backgroundColor: lesson.is_completed == 1 ? 'green' : 'gray' }}>
  <div className="w-100 d-flex flex-column flex-md-row align-items-center justify-content-between">

    {/* Left side: Icons and lesson type */}
    <div className="d-flex align-items-center gap-3 order-2 order-md-1">
      <div style={{ display: "flex", alignItems: "center" }}>
        <FaBookOpen className="icon" style={{ color: "black", marginLeft: "5px", width: "20px" }} />
        <span className="day-text" style={{ color: "black", marginLeft: "5px" }}>{lesson.day}</span>
      </div>
      <Badge
        bg={
          lesson.lessonType === 'I Do'
            ? 'primary'
            : lesson.lessonType === 'We Do'
            ? 'success'
            : 'warning'
        }
        className="d-flex align-items-center gap-1 px-2 py-1"
      >
        {lesson.lessonType === 'I Do' && <i className="bi bi-person-fill fs-3"></i>}
        {lesson.lessonType === 'We Do' && <i className="bi bi-people-fill fs-3"></i>}
        {lesson.lessonType === 'You Do' && <i className="bi bi-person fs-3"></i>}
      </Badge>
      <small className="text-muted color-black">
        <span className="lesson-type-badge">{lesson.lessonType}</span>
      </small>
    </div>

    {/* Center: Title */}
    <div className="flex-grow-1 text-center order-1 order-md-2">
      <h5 className="mb-0">{lesson.lessonTitle}</h5>
    </div>

    {/* Right: Date */}
    <div className="order-3 text-md-end text-start">
      {lesson.is_completed == 1 && (
        <h5 style={{ color: "black", margin: 0 }}>{lesson.date}</h5>
      )}
    </div>
  </div>
</Accordion.Header>


            <Accordion.Body>
                              
        
         
         
          
              <Accordion.Body className="accordion-body">
              {lesson.teacher_name && (
  <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
    <p style={{
      fontSize: "16px",
      fontWeight: "bold",
      color: "#333",
      backgroundColor: "#f8f9fa", 
      padding: "10px 15px",
      borderRadius: "8px",
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", 
      textAlign: "center",
      minWidth: "200px" 
    }}>
      👨‍🏫 Teacher: {lesson.teacher_name}
    </p>
  </div>
)}


              <div className="lesson-card" style={{ backgroundColor: "#ffffff" }}>
               
              <div className="mb-4">
                  <div className="d-flex justify-content-center">
      <Row className="g-4" style={{ maxWidth: '1200px', width: '100%' }}>
        
         {/* <Col md={6} className="d-flex justify-content-center">
          <div className="gallery-section">
            <div className="d-flex flex-column gap-3">
              {lesson.titleAndImagesData?.map((section, idx) => (
                <div key={idx}>
                 <div>
                 
                  <ul style={{ listStyleType: "none" }}>
                    {section.title
                      .split("\n")
                      .slice(0)
                      .map((line, index) =>
                        line.trim() ? (
                          <li key={index} style={{ marginBottom: "5px", fontWeight: 700,fontSize:"16px" }}>
                            {line.trim()}
                          </li>
                        ) : null
                      )}
                  </ul>
                </div>

                 {Object.values(section).some(
  (val) => typeof val === 'string' && val.startsWith('http')
) && (
  <Button
    variant="outline-primary"
    onClick={() =>
      handleImageIconClick(
        Object.values(section).filter(
          (val) => typeof val === 'string' && val.startsWith('http')
        )
      )
    }
    className="image-icon-btn d-flex align-items-center gap-2" style={{marginLeft:"30px"}}
  >
    <FaImage size={20} />
    <span>Show Images</span>
  </Button>
)}
                </div>
              ))}
            </div>
          </div>
        </Col> */}

        <Col md={12}>
  <div className="gallery-section">
    <Row className="g-3">
      {lesson.titleAndImagesData?.map((section, idx) => (
        <Col md={6} key={idx}>
          <div className="p-3 rounded h-100">

            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              {section.title
                .split("\n")
                .map(
                  (line, index) =>
                    line.trim() && (
                      <li
                        key={index}
                        style={{
                          marginBottom: "5px",
                          fontWeight: 700,
                          fontSize: "16px",
                        }}
                      >
                        {line.trim()}
                      </li>
                    )
                )}
            </ul>

            {Object.values(section).some(
              (val) => typeof val === "string" && val.startsWith("http")
            ) && (
              <Button
                variant="outline-primary"
                onClick={() =>
                  handleImageIconClick(
                    Object.values(section).filter(
                      (val) =>
                        typeof val === "string" && val.startsWith("http")
                    )
                  )
                }
                className="d-flex align-items-center gap-2 mt-2"
              >
                <FaImage size={20} />
                <span>Show Images</span>
              </Button>
            )}
          </div>
        </Col>
      ))}
    </Row>
  </div>
</Col>

        {/* <Col md={6} className="d-flex justify-content-center">
          <div className="gallery-section">
            <div className="d-flex flex-column gap-3">
              {lesson.titleAndUrlsData?.map((section, idx) => (
                                  <div key={idx}>
                  <div>
                   
                    <ul style={{ listStyleType: "none" }}>
                      {section.title
                        .split("\n")
                        .slice(0)
                        .map((line, index) =>
                          line.trim() ? (
                            <li key={index} style={{ marginBottom: "5px", fontWeight: 700,fontSize:"16px" }}>
                              {line.trim()}
                            </li>
                          ) : null
                        )}
                    </ul>
                  </div>

                 {Object.values(section).some(
  (val) => typeof val === 'string' && val.startsWith('http')
) && (
  <Button
    variant="outline-success"
    onClick={() =>
      handleVideoIconClick(
        Object.values(section).filter(
          (val) => typeof val === 'string' && val.startsWith('http')
        )
      )
    }
    className="video-icon-btn d-flex align-items-center gap-2" style={{marginLeft:"30px"}}
  >
    <FaVideo size={20} />
    <span>Show Videos</span>
  </Button>
)}

                </div>
              ))}
            </div>
          </div>
        </Col> */}
        <Col md={12}>
  <div className="gallery-section">
    <Row className="g-3">
      {lesson.titleAndUrlsData?.map((section, idx) => (
        <Col xs={12} md={6} key={idx}>
          <div className="p-3 rounded h-100">

            {/* Title */}
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              {section.title
                .split("\n")
                .map(
                  (line, index) =>
                    line.trim() && (
                      <li
                        key={index}
                        style={{
                          marginBottom: "5px",
                          fontWeight: 700,
                          fontSize: "16px",
                        }}
                      >
                        {line.trim()}
                      </li>
                    )
                )}
            </ul>

            {/* Show Videos Button */}
            {Object.values(section).some(
              (val) => typeof val === "string" && val.startsWith("http")
            ) && (
              <Button
                variant="outline-success"
                onClick={() =>
                  handleVideoIconClick(
                    Object.values(section).filter(
                      (val) =>
                        typeof val === "string" && val.startsWith("http")
                    )
                  )
                }
                className="d-flex align-items-center gap-2 mt-2"
              >
                <FaVideo size={20} />
                <span>Show Videos</span>
              </Button>
            )}
          </div>
        </Col>
      ))}
    </Row>
  </div>
</Col>

      </Row>
    </div>

      {/* {lesson?.homework && <div className="mb-4">
      <Card className="mb-3 mt-3">
        <Card.Body className="d-flex align-items-center">
          <FaBook size={24} style={{ marginRight: 16, color: '#007bff' }} />
          <h5 className="m-0">Homework :  {lesson?.homework || 'No homework assigned.'} </h5>
        </Card.Body>
      </Card> */}

      {/* Homework Content */}
      {/* <Card className="bg-light">
        <Card.Body>
          <p>{lesson?.homework || 'No homework assigned.'}</p>
        </Card.Body>
      </Card> 
    </div>} */}

   {/* <div className="container mt-4">

      <div className="d-flex gap-3">

        {lesson.homework && lesson.homework.trim() !== "" && (
          <button className="btn btn-primary" onClick={() => openModal("homework")}>
            Homework
          </button>
        )}

        {lesson.conclusion && lesson.conclusion.trim() !== "" && (
          <button className="btn btn-success" onClick={() => openModal("conclusion")}>
            Conclusion
          </button>
        )}

        {lesson.studentWillDo && lesson.studentWillDo.trim() !== "" && (
          <button className="btn btn-warning" onClick={() => openModal("studentWillDo")}>
            Student Will Do
          </button>
        )}

      </div>

      {showModal && (
       <Modal show={showModal} onHide={closeModal} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>{keyLabels[selectedKey]}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
      {lesson[selectedKey]}
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={closeModal}>
      Cancel
    </Button>
  </Modal.Footer>
</Modal>
      )}

    </div> */}
    <div className="container mt-4">

  {/* Buttons Row */}
  <div className="d-flex flex-column flex-md-row gap-3">
 {lesson.studentWillDo && lesson.studentWillDo.trim() !== "" && (
      <button
        className="btn btn-warning w-100 w-md-auto"
        onClick={() => openModal("studentWillDo")}
      >
        Student Will Do
      </button>
    )}
    {/* Homework Button */}
   

    {/* Conclusion Button */}
    {lesson.conclusion && lesson.conclusion.trim() !== "" && (
      <button
        className="btn btn-success w-100 w-md-auto"
        onClick={() => openModal("conclusion")}
      >
        Conclusion
      </button>
    )}
 {lesson.homework && lesson.homework.trim() !== "" && (
      <button
        className="btn btn-primary w-100 w-md-auto"
        onClick={() => openModal("homework")}
      >
        Homework
      </button>
    )}
    {/* Student Will Do Button */}
   

  </div>

  {/* Modal */}
  {showModal && (
    <Modal show={showModal} onHide={closeModal} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{keyLabels[selectedKey]}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
  <div
    style={{
      whiteSpace: "pre-wrap",
      lineHeight: "1.5",
      fontSize: "20px",
      fontWeight: 500,
      color: "#333",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      letterSpacing: "0.3px",
    }}
  >
    {lesson[selectedKey]}
  </div>
</Modal.Body>


      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )}

</div>

              </div>
              </div>

              <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
              {lesson.file1 && <img src={lesson.file1} className="preview-image" style={{ width: "150px", height:'150px',  borderRadius: "8px" }} />}
              {lesson.file2 && <img src={lesson.file2} className="preview-image" style={{ width: "150px",  height:'150px', borderRadius: "8px" }} />}
              {lesson.file3 && <img src={lesson.file3} className="preview-image" style={{ width: "150px",  height:'150px', borderRadius: "8px" }} />}
            </div>

              
              </Accordion.Body>
         
              
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>)}

      {/* Modal to show images */}
      <ModalShowImages
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        dataList={selectedImages}
      />

      {/* Modal to show videos */}
      <ModalShowVideos
        show={showVideoModal}
        onHide={() => setShowVideoModal(false)}
        dataList={selectedVideos}
      />

      {/* Accordion */}
      {/* <Accordion className="crazy-accordion">
        {data.map((lesson, index) => {
          const bgColor = lesson.is_completed == 1 ? 'green' : 'gray';// Get a random color for each lesson
          return (
            <Accordion.Item eventKey={String(index)} key={lesson.id} className="crazy-accordion-item">
             <Accordion.Header className="lesson-accordion-header" style={{ backgroundColor: bgColor }}>
              <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FaBookOpen className="icon" style={{ color: "white", marginLeft: "5px", width: "20px" }} />
                  <span className="day-text" style={{ color: "white", marginLeft: "5px" }}>{lesson.day}</span>
                </div>

                {lesson.is_completed == 1 && (
                  <span style={{ color: "white", marginLeft: "auto", textAlign: "right",marginRight:'5px' }}>
                    {lesson.date}
                  </span>
                )}
              </div>
            </Accordion.Header>
              <Accordion.Body className="accordion-body">
              {lesson.teacher_name && (
  <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
    <p style={{
      fontSize: "16px",
      fontWeight: "bold",
      color: "#333",
      backgroundColor: "#f8f9fa", 
      padding: "10px 15px",
      borderRadius: "8px",
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", 
      textAlign: "center",
      minWidth: "200px" 
    }}>
      👨‍🏫 Teacher: {lesson.teacher_name}
    </p>
  </div>
)}


              <div className="lesson-card" style={{ backgroundColor: getRandomColor() }}>
                <h2 className="lesson-plan">
  

  <div>
  <strong>{lesson.plan.split("\n")[0].trim()}</strong>
  <br />
  <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
    {lesson.plan
      .split("\n")
      .slice(1) 
      .map((line, index) =>
        line.trim() ? (
          <li key={index} style={{ marginBottom: "5px" }}>
            {line.trim()}
          </li>
        ) : null
      )}
  </ul>
</div>
              </h2>
              </div>

              <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
  {lesson.file1 && <img src={lesson.file1} className="preview-image" style={{ width: "150px", height:'150px',  borderRadius: "8px" }} />}
  {lesson.file2 && <img src={lesson.file2} className="preview-image" style={{ width: "150px",  height:'150px', borderRadius: "8px" }} />}
  {lesson.file3 && <img src={lesson.file3} className="preview-image" style={{ width: "150px",  height:'150px', borderRadius: "8px" }} />}
</div>

              
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion> */}
    </div>
  );
};

export default DayPlan;
